import React, {Fragment} from 'react';

import { PATH_MARKETING_PRICING } from '~/common/utils/consts.js';

// Import Components
import BoxWrapper from "~/common/components/BoxWrapper";
import CommonButton from '~/common/components/CommonButton';

import styles from './error-view.css';

const ErrorView = () => {
    return (
        <section className={styles.wrapper}>
            <BoxWrapper>
                <Fragment>
                    <h2>Oh no!</h2>
                    <p className={styles.copy}>We are currently experiencing a problem, <br />please try again</p>
                    <CommonButton
                        href="/"
                        modifier={styles.button}
                    >
                        Start over
                    </CommonButton>
                </Fragment>
            </BoxWrapper>
        </section>
    );
};

export default ErrorView;
